"use client";
import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import CustomGsapHeaderAnimate from "../utils/CustomGsapHeaderAnimate";

// Make sure to register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);
const InfoSection = () => {
  useEffect(() => {
    // GSAP animation for rv-12-infos-vectors
    gsap.to("#rv-12-infos-vectors", {
      x: -400,
      duration: 0.1,
      ease: "Linear.easeNone",
      scrollTrigger: {
        trigger: "#rv-12-infos-vectors",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });

    // GSAP animation for rv-12-infos-vectors-2
    gsap.to("#rv-12-infos-vectors-2", {
      x: 250,
      duration: 0.1,
      ease: "Linear.easeNone",
      scrollTrigger: {
        trigger: "#rv-12-infos-vectors-2",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });
  }, []);
  return (
    <>
      <CustomGsapHeaderAnimate className="text-center pt-120 pb-15">
        <h2 className="rv-7-section__title rv-text-anime">Why choose Us?</h2>
      </CustomGsapHeaderAnimate>

      <div className="container text-center text-muted pb-30 w-75">
        <p>
          Our Little Millets offer a <strong>Premium</strong> ,{" "}
          <strong>Nutritious</strong>, and <strong>Gluten-free</strong>
          alternative to traditional grains. Packed with <strong>
            Fiber
          </strong>, <strong>Vitamins</strong>, and
          <strong> Essential minerals</strong>
        </p>
        <p>
          It support a healthy lifestyle. Grown with sustainable practices and
          free from harmful chemicals, our millets are perfect for
          health-conscious consumers looking for a wholesome, versatile option
          in their diet.<strong>Quality</strong> ,<strong>taste</strong> , and
          <strong> freshness</strong> are our priorities, making our Little
          Millets the ideal choice for a <strong>balanced diet</strong> .
        </p>
      </div>
      <section
        className="rv-12-infos pt-160 pb-160"
        style={{ backgroundColor: "#012307" }}
      >
        <div className="container">
          <div className="row align-items-center rv-12-infos__row rv-9-guides__row justify-content-evenly">
            <div className="col-xl-4 col-lg-5 col-6 col-xxs-12">
              <div className="rv-8-service rv-9-guide rv-12-info">
                <div className="rv-9-service__icon">
                  <img src="assets/img/rv-12-info-1.png" alt="Icon" />
                </div>

                <div className="rv-9-guide__txt">
                  <h4 className="rv-3-service__title">
                    <a href="#">High-Quality Millet Products</a>
                  </h4>
                  <p className="rv-3-service__descr">
                    Delivers nutritious, sustainable millet-based food products
                    for global consumers.
                  </p>
                </div>
              </div>

              <div className="rv-8-service rv-9-guide rv-12-info">
                <div className="rv-9-service__icon">
                  <img src="assets/img/rv-12-info-2.png" alt="Icon" />
                </div>

                <div className="rv-9-guide__txt">
                  <h4 className="rv-3-service__title">
                    <a href="#">Commitment to Healthy Lifestyles</a>
                  </h4>
                  <p className="rv-3-service__descr">
                    Promotes healthier dietary choices through diverse millet
                    offerings.
                  </p>
                </div>
              </div>

              <div className="rv-8-service rv-9-guide rv-12-info">
                <div className="rv-9-service__icon">
                  <img src="assets/img/rv-12-info-3.png" alt="Icon" />
                </div>

                <div className="rv-9-guide__txt">
                  <h4 className="rv-3-service__title">
                    <a href="#">Focus on Sustainability</a>
                  </h4>
                  <p className="rv-3-service__descr">
                    Supports eco-friendly agriculture to build a sustainable
                    future for communities.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-4 d-none d-xl-block">
              <div className="rv-9-guides__img text-center">
                <img src="assets/hindustanpurefoods/cardImage.webp" alt="" />
              </div>
            </div>

            <div className="col-xl-4 col-lg-5 col-6 col-xxs-12">
              <div className="rv-8-service rv-9-guide rv-12-info">
                <div className="rv-9-service__icon">
                  <img src="assets/img/rv-12-info-4.png" alt="Icon" />
                </div>

                <div className="rv-9-guide__txt">
                  <h4 className="rv-3-service__title">
                    <a href="#">Cutting-Edge Facilities</a>
                  </h4>
                  <p className="rv-3-service__descr">
                    Guarantees superior quality and hygiene with innovative,
                    advanced manufacturing processes.
                  </p>
                </div>
              </div>

              <div className="rv-8-service rv-9-guide rv-12-info">
                <div className="rv-9-service__icon">
                  <img src="assets/img/rv-12-info-5.png" alt="Icon" />
                </div>

                <div className="rv-9-guide__txt">
                  <h4 className="rv-3-service__title">
                    <a href="#">Preservation of Traditional Values</a>
                  </h4>
                  <p className="rv-3-service__descr">
                    Blends modern dietary needs with the heritage of
                    millet-based nutrition.
                  </p>
                </div>
              </div>

              <div className="rv-8-service rv-9-guide rv-12-info">
                <div className="rv-9-service__icon">
                  <img src="assets/img/rv-12-info-6.png" alt="Icon" />
                </div>

                <div className="rv-9-guide__txt">
                  <h4 className="rv-3-service__title">
                    <a href="#">Global Millet Advocacy</a>
                  </h4>
                  <p className="rv-3-service__descr">
                    Aims to make millets a household staple worldwide for better
                    health.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rv-12-infos__vectors" id="rv-12-infos-vectors">
          <img
            src="/assets/hindustanpurefoods/rv-12-infos-vector.png"
            alt="vector"
            className="rv-12-infos-vector"
          />
          <img
            src="/assets/hindustanpurefoods/rv-12-infos-vector.png"
            alt="vector"
            className="rv-12-infos-vector"
          />
        </div>
        <div
          className="rv-12-infos__vectors rv-12-infos__vectors--2"
          id="rv-12-infos-vectors-2"
        >
          <img
            src="/assets/hindustanpurefoods/rv-12-infos-vector.png"
            alt="vector"
            className="rv-12-infos-vector"
          />
          <img
            src="/assets/hindustanpurefoods/rv-12-infos-vector.png"
            alt="vector"
            className="rv-12-infos-vector"
          />
        </div>
      </section>
    </>
  );
};

export default InfoSection;
